<div [class]="externalClass" [ngClass]="{
  'green': color === NorthernColors.Green,
  'red': color === NorthernColors.Red,
  'blue': color === NorthernColors.Blue,
  'yellow': color === NorthernColors.Yellow,
  'orange': color === NorthernColors.Orange,
  'purple': color === NorthernColors.Purple,
  'pink': color === NorthernColors.Pink,
  'cyan': color === NorthernColors.Cyan,
  'white': color === NorthernColors.White,

  'flash-effect': flash,  
  'flash-green': flash && flashColor === NorthernColors.Green,
  'flash-red': flash && flashColor === NorthernColors.Red,
  'flash-blue': flash && flashColor === NorthernColors.Blue,
  'flash-yellow': flash && flashColor === NorthernColors.Yellow,
  'flash-orange': flash && flashColor === NorthernColors.Orange,
  'flash-purple': flash && flashColor === NorthernColors.Purple,
  'flash-pink': flash && flashColor === NorthernColors.Pink,
  'flash-cyan': flash && flashColor === NorthernColors.Cyan,
  'flash-white': flash && flashColor === NorthernColors.White
}">
  <ng-content></ng-content>
</div>